import React from "react";
import {Button, Form, InputNumber, message, Modal, Tooltip,Input} from "antd";
import {WasteStreamGet, WasteStreamPost, WasteStreamRemove, WasteStreamUpdate} from "../../../../models/waste_stream";
import {WasteStreamFilter} from "../../../../filters/WasteStreamCode";
import {ServiceUpdate} from "../../../../models/service";
import {isEmpty} from 'lodash'
import {EditQuantity} from "./EditQuantity";

const FormItem = Form.Item;

class HotsheetQuantityUpdateForm extends React.Component {
  state = {
    service: {},
    ws_id: 0,
    value: [],
    editText:false,
  };

  handleUpdateWasteStream = () => {
    message.success('Waste Stream Updated successfully');
    this.props.fetch();
    this.props.setModelVisible(false)
  };

  SubmitWasteStream = () => {
    let {ws_id, service} = this.state;
    const manifest = service.id;
    const {form} = this.props;
    form.validateFields((err, values) => {
      let ws_ids = service.waste_data.map(ws => ws.id);
        if (!err) {
          WasteStreamPost(values)
            .then(response => {
              ws_ids = [response.id, ...ws_ids];
              ServiceUpdate(manifest, {'waste_stream': ws_ids})
                .then(service_response => {
                  service = service_response;
                  form.resetFields();
                  this.waste_stream_code.resetValue();
                  this.setState({service});
                })
            })
        }
    });
  };

  updateWasteStream = (index, id) => {
    this.setState({editText:true})
    const {service} = this.state;
    const waste_stream = service.waste_data[index];
    this.setState({ws_id: id});
    this.props.form.setFieldsValue({
      quantity: waste_stream.quantity,
      price: waste_stream.price,
      container_size: waste_stream.container_size,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const {service} = this.state;
    const {row} = this.props;
    if (isEmpty(row.service) !== isEmpty(service)) {
      this.setState({service: row.service});
    }
  }
  updateService=(service)=>{
    this.setState(service)
  }
  render() {
    const {visible} = this.props;
    const {service, ws_id, editText} = this.state;
    const {getFieldDecorator} = this.props.form;

    return (
      <Modal title="Edit Quantity" width={"70%"} centered visible={visible} onOk={this.handleUpdateWasteStream}
             onCancel={() => this.props.setModelVisible(false)} okText="Update Quantity" destroyOnClose={true}>
          <div className={"edit-qty-modal"}>
            <div className="row">
              <div className="col-sm-6 col-12">
                <FormItem label="Waste Stream">
                  {getFieldDecorator('waste_stream', {
                    rules: [{required: true, message: 'Please select waste stream code'}],
                  })(<WasteStreamFilter onRef={ref => (this.waste_stream_code = ref)}/>)}
                </FormItem>
              </div>
              <div className="col-sm-2 col-12">
                <FormItem label="Quantity">
                  <Tooltip title="Estimated gallons picked up">
                    {getFieldDecorator('quantity')(<InputNumber placeholder="Quantity"/>)}
                  </Tooltip>
                </FormItem>
              </div>
              <div className="col-sm-2 col-12">
                <FormItem label="Price">
                  {getFieldDecorator('price',)(<InputNumber placeholder="Price" min={0} step={0.1}/>)}
                </FormItem>
              </div>
              <div className="col-sm-2 col-12">
                <FormItem label="# of Containers">
                  {getFieldDecorator('container_size')(<InputNumber placeholder="Containers"/>)}
                </FormItem>
              </div>
              <div className="col-12 ws-btn-div">
                <button type="button" onClick={this.SubmitWasteStream} className="ant-btn ant-btn-primary m-t-5">
                   Add Waste Stream</button>
              </div>
            </div>
            <EditQuantity service={service} updateService={(service)=>this.updateService(service)}/>

          </div>
      </Modal>
    )
  }
}

export const HotsheetQuantityUpdate = Form.create()(HotsheetQuantityUpdateForm);



// WEBPACK FOOTER //
// ./src/pages/tracks/work_perform/hotsheet_performed/HotsheetQuantityUpdate.jsx